import _ from 'lodash';
import Icon from 'vue-awesome/components/Icon.vue';

Icon.register({
  'hand-holding-box': {
    width: 576,
    height: 512,
    d: 'M112 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H352v128l-64-32-64 32V0H112c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm453.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z',
  },
});

export default {
  components: {
    'icon-custom': Icon,
  },
  props: {
    creative: Object,
  },
  computed: {
    fields() {
      return this.creative;
    },
    settings() {
      const isOnline = ['online', 'both'].indexOf(this.creative.offer_config.redeem) !== -1;
      const isInStore = ['store', 'both'].indexOf(this.creative.offer_config.redeem) !== -1;
      const showCode = this.fields.code_type === 'one' && !_.isEmpty(this.fields.code);
      return {
        isOnline,
        showOnline: isOnline && showCode,
        showInStore: isInStore && showCode,
      };
    },
    imageUrl() {
      return _.get(this.creative, 'media[0].thumbnail', false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/offer-form-preview/OfferFormPreview.js